/**
 * DHIQUEST tabs: progressive enhancement for [data-dq-tabs] containers.
 * Markup: a direct [role="tablist"] (hidden until enhanced) whose [role="tab"]
 * buttons point to [role="tabpanel"] elements via aria-controls. Nested tab
 * sets are supported. Without JavaScript all panels stay visible.
 * Keyboard: Left/Right (and Up/Down) move between tabs, Home/End jump.
 */
(() => {
  function enhance(container) {
    if (container.classList.contains('is-enhanced')) return;
    const tablist = container.querySelector(':scope > [role="tablist"], :scope > * > [role="tablist"]');
    if (!tablist) return;
    const tabs = Array.from(tablist.querySelectorAll(':scope > [role="tab"]'));
    if (!tabs.length) return;

    const panelFor = (tab) => document.getElementById(tab.getAttribute('aria-controls'));

    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const selected = t === tab;
        t.setAttribute('aria-selected', String(selected));
        t.tabIndex = selected ? 0 : -1;
        const panel = panelFor(t);
        if (panel) panel.hidden = !selected;
      });
      if (focus) tab.focus();
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => select(tab, false));
      tab.addEventListener('keydown', (event) => {
        const i = tabs.indexOf(tab);
        let next = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = tabs[(i + 1) % tabs.length];
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (event.key === 'Home') next = tabs[0];
        if (event.key === 'End') next = tabs[tabs.length - 1];
        if (next) {
          event.preventDefault();
          select(next, true);
        }
      });
    });

    const initial = tabs.find((t) => t.getAttribute('aria-selected') === 'true') || tabs[0];
    tablist.hidden = false;
    container.classList.add('is-enhanced');
    select(initial, false);
  }

  const init = (root = document) => root.querySelectorAll('[data-dq-tabs]').forEach(enhance);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
